import * as React from 'react';
import { AppBar, IconButton, PaperProps, Toolbar, Typography } from '@mui/material';
import { NavLink, useLocation } from 'react-router';
import { ArrowBack } from '@mui/icons-material';


interface Props extends PaperProps {
    title?: string;
    actions?: string | JSX.Element | JSX.Element[];
    children: React.ReactNode;
}

const AppBarPage = ({ title, actions, children, sx, ...props }: Props): JSX.Element => {
    const location = useLocation();
    return (
        <>
            <AppBar position="relative" >
                <Toolbar sx={{ color: 'white' }}>
                    <NavLink to='/' 
                        style={{
                            visibility: location.pathname>'/' ? 'visible' : 'hidden',
                            color: 'inherit'
                        }}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                        >
                            <ArrowBack />
                        </IconButton>
                    </NavLink>
                    <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
                        {title}
                    </Typography>
                    {actions}
                </Toolbar>
            </AppBar>
            {children}
        </>
    );
}

export default AppBarPage;